import { useState, useEffect } from "react";
import { Popconfirm } from "antd";
import Checkbox from "@/common/elements/InputElements/CheckBox";
import FormItem from "@/common/elements/InputElements/FormItem.jsx";
import { StyledGridCol, StyledGridRow } from "@/common/styles";
import { getOptionsFromRefList } from "@/util/common_function";
import { useDispatch } from "react-redux";
import { setDeleteAPis } from "@/slices/bookingsSlice";
import API_ENDPOINTS from "@/util/api";

const BookingQueueStepFilter = ({
  bookingQueueDetails = [],
  onStepChange,
  onOpenModal,
  disabled,
}) => {
  const bookingQueueSteps = getOptionsFromRefList(
    "BookingQueueStep",
    false,
    false,
    true
  )?.slice(1);

  const dispatch = useDispatch();
  const [selectedSteps, setSelectedSteps] = useState(new Set());
  const [persistedMapping, setPersistedMapping] = useState({});

  useEffect(() => {
    const stepsWithID = bookingQueueDetails
      .filter((detail) => detail.complete === true)
      .map((detail) => detail.queStepID);
    setSelectedSteps(new Set(stepsWithID));

    setPersistedMapping(() => {
      const newMapping = {};
      bookingQueueDetails.forEach((detail) => {
        if (detail.bookingQueueDetailID) {
          newMapping[detail.queStepID] = detail.bookingQueueDetailID;
        }
      });
      return newMapping;
    });
  }, [bookingQueueDetails]);

  const handleCheckboxChange = (stepRef, isChecked) => {
    if (isChecked) {
      // Step is being checked
      const stepData = { ...stepRef };
      if (persistedMapping[stepRef.value]) {
        stepData.bookingQueueDetailID = persistedMapping[stepRef.value];
      }
      onOpenModal(stepData, (didSave) => {
        if (didSave) {
          setSelectedSteps((prev) => new Set([...prev, stepRef.value]));
          if (onStepChange) onStepChange(stepRef.value, true);
        }
      });
    }
  };

  return (
    <StyledGridRow gutter={16}>
      {bookingQueueSteps.map((bookStep) => {
        const isChecked = selectedSteps.has(bookStep.value);
        return (
          <StyledGridCol xs={12} lg={8} xl={8} xxl={6} key={bookStep.value}>
            <FormItem
              label={bookStep.label}
              layout="horizontal"
              labelPostion="label-right"
            >
              {isChecked ? (
                <Popconfirm
                  title="Are you sure you want to permanently delete this step?"
                  description={
                    <>
                      <div>
                        Un-checking this box will permanently remove the Step
                        from the Queue.
                      </div>
                      <div>
                        If you want to mark the step as incomplete, click
                        Cancel, then select the step and click the Details
                        button instead.
                      </div>
                    </>
                  }
                  okText="Yes, Delete"
                  cancelText="Cancel"
                  onConfirm={() => {
                    setSelectedSteps((prev) => {
                      const newSet = new Set(prev);
                      newSet.delete(bookStep.value);
                      return newSet;
                    });
                    if (onStepChange) onStepChange(bookStep.value, false);

                    if (persistedMapping[bookStep.value]) {
                      const url =
                        API_ENDPOINTS.bookingQueueDetails +
                        persistedMapping[bookStep.value];
                      dispatch(setDeleteAPis(url));
                    }
                  }}
                >
                  <Checkbox
                    checked={true}
                    disabled={disabled}
                    onClick={(e) => e.stopPropagation()}
                  />
                </Popconfirm>
              ) : (
                <Checkbox
                  checked={isChecked}
                  disabled={disabled}
                  onChange={(e) =>
                    handleCheckboxChange(bookStep, e.target.checked)
                  }
                />
              )}
            </FormItem>
          </StyledGridCol>
        );
      })}
    </StyledGridRow>
  );
};

export default BookingQueueStepFilter;
